import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M12.002 2c-4.173 -.008 -8.002 6.058 -8.002 12.083c0 4.708 3.25 7.917 8 7.917c4.727 -.206 8 -3.328 8 -7.917c0 -6.02 -3.825 -12.075 -7.998 -12.083z","key":"svg-0"}]]

/**
 * IconEggFilled
 * @preview ![img](data:image/svg+xml;base64,PHN2ZwogIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIKICB3aWR0aD0iMjQiCiAgaGVpZ2h0PSIyNCIKICB2aWV3Qm94PSIwIDAgMjQgMjQiCiAgZmlsbD0iY3VycmVudENvbG9yIgogIGNsYXNzPSJpY29uIGljb24tdGFibGVyIGljb25zLXRhYmxlci1maWxsZWQgaWNvbi10YWJsZXItZWdnIgo+CiAgPHBhdGggc3Ryb2tlPSJub25lIiBkPSJNMCAwaDI0djI0SDB6IiBmaWxsPSJub25lIiAvPgogIDxwYXRoIGQ9Ik0xMi4wMDIgMmMtNC4xNzMgLS4wMDggLTguMDAyIDYuMDU4IC04LjAwMiAxMi4wODNjMCA0LjcwOCAzLjI1IDcuOTE3IDggNy45MTdjNC43MjcgLS4yMDYgOCAtMy4zMjggOCAtNy45MTdjMCAtNi4wMiAtMy44MjUgLTEyLjA3NSAtNy45OTggLTEyLjA4M3oiIC8+Cjwvc3ZnPg==) - https://tabler.io/icons/icon/egg-filled
 * @see https://docs.tabler.io/icons/libraries/react - Documentation
 *
 */
const IconEggFilled = createReactComponent('filled', 'egg-filled', 'EggFilled', __iconNode);

export default IconEggFilled;